import { render, staticRenderFns } from "./NoticeBoardItem.vue?vue&type=template&id=51af3592"
import script from "./NoticeBoardItem.vue?vue&type=script&lang=js"
export * from "./NoticeBoardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports